export default __webpack_public_path__ + "static/google-reviews-white-4454040dc225f1316d3f6e335a4c8aa0.svg";